// Company & contact info
export const COMPANY = {
  name: "PT. Animax Putra Lancar",
  brand: "ANIMAX Acrylic",
  tagline: "The Trusted Acrylic for Every Project",
  address: "Dsn. Sidokerto, RT 02, RW 01, Ds. Pulorejo, Kec. Dawarblandong, Kab. Mojokerto, Jawa Timur 61354",
  email: "marketinganimax01@gmail.com",
  instagram: {
    label: "@animax.acrylic",
    url: "https://www.instagram.com/animax.acrylic?igsh=aWlpd3A5cmNhbHU1",
  },
  socialProfiles: [
    {
      key: "email",
      label: "Email",
      handle: "marketinganimax01@gmail.com",
      url: "mailto:marketinganimax01@gmail.com",
    },
    {
      key: "instagram",
      label: "Instagram",
      handle: "@animax.acrylic",
      url: "https://www.instagram.com/animax.acrylic?igsh=aWlpd3A5cmNhbHU1",
    },
    {
      key: "tiktok",
      label: "TikTok",
      handle: "@animax_putra_lancar",
      url: "https://www.tiktok.com/@animax_putra_lancar",
    },
    {
      key: "x",
      label: "X (Twitter)",
      handle: "@animax_apl",
      url: "https://twitter.com/animax_apl",
    },
    {
      key: "youtube",
      label: "YouTube",
      handle: "Animax Putra Lancar",
      url: "https://www.youtube.com/channel/UCD1VdEmwxX_brQ_9bRbXEGw",
    },
    {
      key: "facebook",
      label: "Facebook",
      handle: "animax.lancar",
      url: "https://www.facebook.com/animax.lancar/",
    },
  ],
  hours: [
    { day: "Senin", time: "08.00 – 12.00, 13.00 – 17.00" },
    { day: "Selasa", time: "08.00 – 12.00, 13.00 – 17.00" },
    { day: "Rabu", time: "08.00 – 12.00, 13.00 – 17.00" },
    { day: "Kamis", time: "08.00 – 12.00, 13.00 – 17.00" },
    { day: "Jumat", time: "08.00 – 12.00, 13.00 – 17.00" },
    { day: "Sabtu", time: "08.00 – 12.00, 13.00 – 17.00" },
    { day: "Minggu", time: "Tutup" },
  ],
  whatsapp: [
    { name: "KEN", number: "+62 811-3215-881", raw: "628113215881", tel: "+628113215881" },
    { name: "RIO", number: "+62 811-3116-676", raw: "628113116676", tel: "+628113116676" },
    { name: "RAYMOND", number: "+62 818-0781-7181", raw: "6281807817181", tel: "+6281807817181" },
  ],
  mapsQuery: "PT+Animax+Putra+Lancar+Pulorejo+Dawarblandong+Mojokerto",
  logos: {
    animaxBadge: "https://customer-assets.emergentagent.com/job_supplier-acrylic/artifacts/0rb6it6i_IMG_4200.PNG",
    animaxFull: "https://customer-assets.emergentagent.com/job_supplier-acrylic/artifacts/aj1bb7ez_b9022f7a-bada-4a84-9706-a708fdfa4eda.JPG",
    aplCorporate: "https://customer-assets.emergentagent.com/job_supplier-acrylic/artifacts/rfe5uqva_IMG_4202.PNG",
    aplTransparent: "/logos/apl-transparent.png",
  },
};

export const primaryWA = COMPANY.whatsapp[0];

export const waLink = (raw, text) =>
  `https://wa.me/${raw}?text=${encodeURIComponent(text || "Halo, saya ingin bertanya tentang produk dari PT. Animax Putra Lancar")}`;

export const NAV_LINKS = [
  { label: "Produk", href: "/#produk" },
  { label: "Profil Perusahaan", href: "/profil-perusahaan/" },
  { label: "Kemitraan", href: "/#kemitraan" },
  { label: "Kontak Kami", href: "/kontak/" },
];

export const PRODUCT_MENU = [
  { label: "Acrylic Sheet", href: "/produk/animax-acrylic-sheet/", analyticsName: "Acrylic", available: true },
  { label: "Baja Ringan & Galvalum", href: "/produk/baja-ringan-galvalum/", analyticsName: "Galvalum", available: true },
  { label: "Kitchen Equipment", href: "/produk/kitchen-equipment/", analyticsName: "Kitchen Equipment", available: true },
  { label: "Elektronik", href: "/produk/elektronik/", analyticsName: "Elektronik", available: true },
];

export const PHOTOS = {
  kantorDisplay: "/images/kantor-display.jpg",
  animaxProductionMachine: "/images/animax-production-machine.jpg",
  galvalumWarehouse: "/images/galvalum-warehouse.jpg",
  galvalumProjectBlueRoof: "/images/galvalum-project-blue-roof.jpeg",
  galvalumProjectBuilding: "/images/galvalum-project-building.jpg",
  galvalumProjectBlueCeiling: "/images/galvalum-project-blue-ceiling.jpg",
  galvalumProjectMetalRoof: "/images/galvalum-project-metal-roof.jpg",
  galvalumProjectStructure: "/images/galvalum-project-structure.jpg",
  galvalumProjectSheepStructure: "/images/galvalum-project-sheep-structure.jpg",
  produksiMesin: "https://customer-assets.emergentagent.com/job_supplier-acrylic/artifacts/5xj9wi8u_ChatGPT%20Image%20Jul%202%2C%202026%2C%2002_26_40%20PM%20%287%29.png",
  produksiRak: "https://customer-assets.emergentagent.com/job_supplier-acrylic/artifacts/ayuz90gq_ChatGPT%20Image%20Jul%202%2C%202026%2C%2002_26_40%20PM%20%288%29.png",
  produkSignage: "https://customer-assets.emergentagent.com/job_supplier-acrylic/artifacts/mfc16y0v_ChatGPT%20Image%20Jul%202%2C%202026%2C%2003_20_43%20PM%20%282%29.png",
  produkPlakat: "https://customer-assets.emergentagent.com/job_supplier-acrylic/artifacts/dkn471rj_ChatGPT%20Image%20Jul%202%2C%202026%2C%2003_20_43%20PM%20%283%29.png",
  produkEmblem: "https://customer-assets.emergentagent.com/job_supplier-acrylic/artifacts/y8u6a3pq_ChatGPT%20Image%20Jul%202%2C%202026%2C%2003_20_46%20PM%20%285%29.png",
};
